<template lang="pug">
v-main
  v-container(fluid)
    div(style="display: flex;justify-content: space-between;padding: 1rem;background: white;padding-bottom: .2rem;")
      p(style="font-size: 1.25rem;line-height: 1.5;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;") Create New Payment Request
      v-btn(v-if="$route.name !== 'Forex Request' && $route.name !== 'Document Legal F1' && $route.name !== 'Document Legal F2'" color='blue-secondary' to='/my-request') LIST MEMO

    v-stepper(v-model="e1")
      v-stepper-header
        v-stepper-step(:complete="e1 > 1" step="1")
          | Memo Details
        v-divider
        v-stepper-step(:complete="e1 > 2" step="2")
          | Payment Details
        v-divider
        v-stepper-step(step="3") Approval
      v-stepper-items
        v-stepper-content(step="1")
          v-card.mb-2(style="box-shadow: none")
            //- | HALAMAN `1`
            v-card(flat)
              v-card-text.p-5
                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    v-subheader(color="black")
                      | &nbsp;Business Unit&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-autocomplete(
                      style="padding: 0",
                      label="Select Business Unit",
                      id="imPaySelectBU"
                      :items="myBuList",
                      item-text="label",
                      item-value="value",
                      v-model="imPayDataSelectedBU",
                      placeholder="Select",
                      required
                      @change="trigerChange"
                    )

                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Subject&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-text-field(
                      style="padding: 0",
                      label="Subject",
                      id="imPaySubject"
                      v-model="imPayDataPurpose"
                    )

                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Invoice No&nbsp;
                      span(style="color: #d42a2a") 
                  v-col(cols="8")
                    v-text-field(
                      style="padding: 0",
                      id="imPayInvoiceNo"
                      label="Invoice No",
                      v-model="imPayDataInvoiceNo"
                    )

                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Invoice Date&nbsp;
                      span(style="color: #d42a2a") 
                  v-col(cols="8")
                    v-menu(
                      v-model="pickerStyle"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto")
                    
                      template(v-slot:activator="{ on, attrs }")
                        v-text-field(
                          v-model="imPayDataInvoiceDate"
                          id="imPayInvoiceDate"
                          label="Select Invoice Date"
                          prepend-icon="event"
                          readonly
                          v-bind="attrs"
                          v-on="on")
                        
                      v-date-picker(
                        v-model="imPayDataInvoiceDate"
                        @input="pickerStyle = false")

                    //- v-text-field(
                    //-   style="padding: 0",
                    //-   label="Invoice Date",
                    //-   v-model="imPayDataInvoiceDate"
                    //- )

                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Tax No&nbsp;
                      span(style="color: #d42a2a") 
                  v-col(cols="8")
                    v-text-field(
                      id="imPayTaxNo"
                      style="padding: 0",
                      label="Tax No",
                      v-model="imPayDataTaxNo"
                    )

                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Purpose&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-text-field(
                      id="imPayPurpose"
                      style="padding: 0",
                      label="Purpose",
                      v-model="imPayDataTujuan"
                    )

                v-row
                  v-col(cols="3") 
                    v-subheader(color="black")
                      span(style="font-size: 16px; font-weight: 600") Attachment File
                  v-col(cols="8")
                    v-flex(xs12, sm6, md12, mb-2)
                      ul(
                        v-if=" fileName.length > 0",
                        style="color: #8e8e8e; margin-top: -10px"
                      )
                        li.mt-2(v-if="item.url != null" v-for="item in fileName") 
                          v-chip(v-if="item.url != null") 
                            span(v-if="item.url") {{ item.url.slice(41, 999) | truncate(15, '...') }}
                            span(v-else) ''
                      div.mt-1(style="font-size: 14px") 
                        input#file(
                          v-if="fileName.length > 0",
                          type="file",
                          ref="fileadd",
                          style="display: none",
                          v-on:change="addFile()",
                          accept=".pdf, .doc, .zip, .docx, .xlsx, .xls, image/*",
                          multiple
                        )
                        v-btn(
                          v-if="fileName.length > 0",
                          outlined,
                          color="primary",
                          @click="$refs.fileadd.click()"
                        ) 
                          v-icon add
                          | Add file
                        input#file(
                          v-if="fileName.length == 0",
                          type="file",
                          ref="file",
                          style="display: none",
                          v-on:change="uploadLampiran()",
                          accept=".7z, .rar, .pdf, .doc, .docx, .zip, .xlsx, .xls, image/*",
                          multiple
                        )
                        v-btn(
                          v-if="fileName.length == 0",
                          outlined,
                          color="primary",
                          @click="$refs.file.click()"
                        ) 
                          v-icon add
                          | Add file
                        p.mt-1 Max Size: 5 MB. Allowed: .pdf, .doc, .zip, .7zip, .rar,  .docx, .xlsx, .xls, or images
                        v-alert.mt-2(
                          v-model="uploadAlert",
                          color="red",
                          dense,
                          text,
                          dismissible
                        ) The file is too big. Max file size 5 MB
                        v-spacer.mt-2
                        //- b(style="font-size:14px; font-weight: 600;") total files: {{fileName.length}}
                        v-row.mt-1
                          v-chip.ma-2(
                            v-if="fileName.length > 0",
                            v-for="(item, index) in fileName",
                            :key="item",
                            close,                        
                            @click:close="removeLampiran(item, index)" 
                          )
                            span(v-if="item.name != null") {{ item.name | truncate(15, '...') }}
                            span(v-else) {{ item | truncate(15, '...') }}
                v-subheader(style="color: #000;font-family: Roboto;font-size: 16px;font-style: normal;font-weight: 600;line-height: normal;") &nbsp;Pay To&nbsp;

                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Bank Name&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-autocomplete(
                      id="imPayBankName"
                      style="padding: 0",
                      label="Select Bank",
                      :items="masterBank",
                      :filter="customFilter"
                      item-title="text",
                      v-model="imPayDataBankName", 
                      placeholder="Select Bank Name",
                      required
                    )
                      template(v-slot:item="data")
                        p {{data.item.text}}

                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Bank Account No&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-text-field(
                      id="imPayBankNo"
                      @keypress="numberOnly(event)"
                      @paste="disablePaste"
                      style="padding: 0",
                      label="Bank Account No",
                      v-model="imPayDataBankNo"
                    )

                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Bank Account Name&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-text-field(
                      id="imPayBankAccountName"
                      style="padding: 0",
                      label="Bank Account Name",
                      v-model="imPayDataPayTo"
                    )
          v-btn(style="background-color: #f5f5f5;" depressed, large, id="imPayPage1Cancel" text="" @click="$router.push('/my-request')") Cancel
          v-btn(depressed, large, id="imPayPage1Next" style="margin: 0.5rem" :disabled="form1Validation" color="primary", @click="e1 = 2") Next
        v-stepper-content(step="2")
          v-dialog(v-model='dialogConfirmDelete' max-width='400')
            v-card
              <svg style="margin: 1rem 1rem 0rem 1rem;" width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Delete outline" clip-path="url(#clip0_6670_35732)">
                <path id="Vector" d="M12 38.5C12 40.7 13.8 42.5 16 42.5H32C34.2 42.5 36 40.7 36 38.5V14.5H12V38.5ZM16 18.5H32V38.5H16V18.5ZM31 8.5L29 6.5H19L17 8.5H10V12.5H38V8.5H31Z" fill="#FF5252"/>
                </g>
                <defs>
                <clipPath id="clip0_6670_35732">
                <rect width="48" height="48" fill="white" transform="translate(0 0.5)"/>
                </clipPath>
                </defs>
              </svg>
              v-card-title.text-h5
                | Delete Items
              v-card-text
                | Do you really want to delete this item?
              v-card-actions()
                v-spacer
                div(style="display:flex; width:100%")
                  v-btn(style="color:#000; flex:1;margin:.3rem" text='' @click='dialogConfirmDelete = false')
                    | No
                  v-btn(style="background:#FF5252;color:#fff; flex:1;margin:.3rem" text='' @click='deleteItem(); dialogConfirmDelete = false')
                    | Yes
          
          v-dialog(v-model='dialogChangeCurency' max-width='400')
            v-card
              v-card-title.text-h5
                | Confirm Currency Change ?
              v-card-text
                | To prevent errors in the total payment due to difference in currency format, the item list will be left blank
              v-card-actions
                v-spacer
                div(style="display:flex; width:100%")
                  v-btn(style="color:#000; flex:1;margin:.3rem" text='' @click='dialogChangeCurency = false; selectedCurrencyInput = oldSelectedCurrency.value; oldSelectedCurrency = {value:"", text: ""}')
                    | No
                  v-btn(style="background:#1976D2;color:#fff; flex:1;margin:.3rem" text='' @click='handleChangeCurrency();changeCurency(); dialogChangeCurency = false')
                    | Yes
          v-card(style="box-shadow: none")
            h2.mb-1 Payment Details
              span.color-red *
            h4(style="margin-bottom:.4rem") Currency
            
            v-autocomplete(
              id="imPayCurrencyBox"
              @change="handleChangeCurrency()"
              v-model="selectedCurrencyInput"
              dense
              :items="currencyBox"
              label="Select an item"
              outlined="",
              single-line="",
              hide-details=""
            )
            div(style="display: flex; width: 100%; padding: 1rem 0")
              div(style="flex: 0 1 47%; margin-right: 1rem; width: 40px",)
                h4(style="margin-bottom:.4rem") Item Name
                v-text-field(
                  v-model="addItemName",
                  id="imPayAddItemName"
                  label="Item Name",
                  dense,
                  :maxlength=50,
                  outlined="",
                  single-line="",
                  hide-details=""
                )
              div(style=style="flex: 0 1 47%; margin-right: 1rem; width: 40px; ",)
                h4(style="margin-bottom:.4rem") Amount Price
                money(
                  id="imPayAddItemPrice"
                  :maxlength="selectedCurrency.value =='IDR' ? 19: 18",
                  style="width: 100%; height: 61%;border-radius: 5px; padding-left: 0.5rem; border: 1px solid #9e9e9e;"
                  v-model="addItemPrice" 
                  v-bind="currencyConfigs[selectedCurrency.value]"
                )
              v-btn.ml-2.white--text(id="imPayAddItemBtn" style="margin-top: auto; margin-bottom: 4px;" color="primary", @click="addNew")
                v-icon(dark="") add
                | Add
            
            v-data-table.elevation-1(
              id="dtbl"
              style="border: 1px solid rgb(222 217 217)" 
              :headers="headers",
              :items="paymentItems",
              fixed-header="",
              height="100%",
              hide-default-footer,
              :items-per-page="-1",
              :header-props="headerProps"
            )
              template(v-slot:item.name="{ item }")
                input(
                  v-model="editedItem.name",
                  :hide-details="true",
                  maxLength=40,
                  style="border:none; outline:none; border-bottom: solid 3px blue; width:100%"
                  dense="",
                  single-line="",
                  :autofocus="true",
                  v-if="item.id === editedItem.id"
                )
                span(v-else="") {{ item.name }}
              template(v-slot:item.amount="{ item }")
                money(
                  v-bind="getMoneyFormat(selectedCurrency.value)"
                  v-model="editedItem.amount",
                  :hide-details="true",
                  :maxlength="selectedCurrency.value =='IDR' ? 23: 22",
                  style="border:none; outline:none; border-bottom: solid 3px blue; width:90%"
                  dense="",
                  single-line="",
                  v-if="item.id === editedItem.id"
                )
                money(v-else v-bind="getMoneyFormat(selectedCurrency.value)" disabled v-model="item.amount") {{ item.amount }}
              template(v-slot:item.actions="{ item }")
                div(v-if="item.id === editedItem.id")
                  v-icon.mr-3(color="red", @click="close")
                    | close
                  v-icon(color="green", @click="save")
                    | save
                div(v-else="")
                  v-icon.mr-3(color="green", @click="editItem(item)")
                    | edit
                  v-icon(color="red", @click="dialogConfirmDelete = true; tempDeleteItem = item")
                    | delete
              template(slot="body.append")
                tr(v-if="paymentItems.length > 0" class="")
                  th(style="font-size:14px !important" class="title") Total Amount
                  th(style="font-size:14px !important" class="title")
                    money(v-bind="getMoneyFormat(selectedCurrency.value)" disabled v-model="totalPayment")
                  th(style="font-size:14px !important" class="title")
              template(v-slot:no-data="")
                div(style="margin :2rem")
                  h2 No items
                  h4 Please input and add item.
            v-toolbar(
              id="ThisToolbar"
              color="white",
              style="width: 100%; padding: 0 !important; box-shadow: none !important"
            )
          v-btn(style="background-color: #f5f5f5;margin: 0.3rem;" depressed, large, id="imPayPage2Cancel" text="" @click="$router.push('/my-request')") Cancel
          v-btn(depressed, large, id="imPayPage2Back" style="margin: 0.3rem; background: #607D8B; color:#fff", @click="e1 = 1") Back
          v-btn(depressed, large, id="imPayPage2Next" style="margin: 0.3rem" :disabled="form2Validation" color="primary", @click="e1 = 3; getMyBUMember();") Next
        v-stepper-content(step="3" style="padding:0")
          v-alert(
            style="margin:0"
            dismissible,
            color="red",
            dark,
            v-model="alert",
            transition="scale-transition"
          ) {{ alertMessage }}
          v-card(style="box-shadow: none; padding:1rem 1rem; border-top: 1px solid #adadad;")
            div(style="display: flex;width: 100%;justify-content: space-between;")
              div(style="padding:0 1rem; flex:1")
                v-autocomplete(
                  id="imPayInternalApprover"
                  style="padding: 0; margin:.5",
                  label="Approver",
                  :items="myBuMember",
                  v-model="approver",
                  placeholder="Select",
                  chips,
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data",
                  return-object,
                  multiple,
                  :append-icon="'close'"
                  @click:append="handleClearEvent(1)"
                  :readonly="max_total_approver !== 0 ? approver.length >= max_total_approver : false"
                )
                  template(v-slot:selection="data")
                    v-chip(
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="removeApp(data.item)"
                    ) {{ data.item.alias }}
                  template(v-slot:item="data")
                    template(v-if="typeof data !== 'object'")
                      v-list-tile-content(v-text="data.item")
                    template(v-else)
                      v-list-tile-content
                        v-list-tile-title.mr-1 {{ data.item.alias }} - {{ data.item.position }} ({{ data.item.business_unit.bu_name }})
                        p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}
                        
                v-autocomplete(
                  :search-input.sync='searchCrossBU' 
                  id="imPayCrossApprover"
                  style="padding: 0; margin:.5",
                  label="Approver Cross BU",
                  v-model="approver",
                  chips
                  color="blue-grey lighten-2"
                  :items="crosBuMember",
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data"
                  multiple
                  :append-icon="'close'"
                  @click:append="handleClearEvent(2)"
                  hide-no-data='' 
                  hint="Enter at least 3 letters to find out the search results."
                  return-object=true
                  :readonly="max_total_approver !== 0 ? approver.length >= max_total_approver : false"
                )
                  template(v-slot:selection="data")
                    v-chip.chip--select-multi(
                      :selected="data.selected",
                      close,
                      @click:close="removeApp(data.item)"
                    ) {{ data.item.alias }}
                  template(v-slot:item="data")
                    template(v-if="typeof data !== 'object'")
                      v-list-tile-content(v-text="data.item")
                    template(v-else)
                      v-list-tile-content
                        v-list-tile-title.mr-1 {{ data.item.alias }} - {{ data.item.position }} ({{ data.item.business_unit.bu_name }})
                        p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}

                v-autocomplete(
                  style="padding: 0; margin:.5",
                  id="imPayInternalCC"
                  label="CC",
                  v-model="tembusan",
                  :items="getCCData",
                  chips,
                  color="blue-grey lighten-2",
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data",
                  return-object,
                  multiple,
                  :append-icon="'close'"
                  @click:append="handleClearEvent(3)"
                  @change="removeCc()"
                  hide-details
                )
                  template(v-slot:selection="data")
                    v-chip.chip--select-multi(
                      :selected="data.selected",
                      close,
                      @click:close="removeCc(data.item)"
                    ) {{ data.item.alias }}
                  template(v-slot:item="data")
                    template(v-if="typeof data !== 'object'")
                      v-list-tile-content(v-text="data.item")
                    template(v-else)
                      v-list-tile-content
                        v-list-tile-title.mr-1 {{data.item.alias}} - {{data.item.position}} ({{ data.item.business_unit.bu_name }})
                        p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}
                        //- v-list-tile-sub-title(v-html="data.item.title")

                small(style="color: #F08703;" ) *CC can only view memo, cannot approve memo.

                v-autocomplete(
                  :search-input.sync='searchCrossCC',
                  id="imPayCrossCC"
                  style="padding: 0; margin:.5",
                  label="Cross CC",
                  v-model="tembusan",
                  :items="getCrossCCData",
                  chips,
                  color="blue-grey lighten-2",
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data",
                  multiple,
                  :append-icon="'close'"
                  @click:append="handleClearEvent(4)"
                  hide-no-data='',
                  @change="removeCc()",
                  hint="Enter at least 3 letters to find out the search results.",
                  return-object=true
                )
                  template(v-slot:selection="data")
                    v-chip.chip--select-multi(
                      :selected="data.selected",
                      close,
                      @click:close="removeCc(data.item)"
                    ) {{ data.item.alias }}
                  template(v-slot:item="data")
                    template(v-if="typeof data !== 'object'")
                      v-list-tile-content(v-text="data.item")
                    template(v-else)
                      v-list-tile-content
                        v-list-tile-title.mr-1 {{data.item.alias}} - {{data.item.position}} ({{ data.item.business_unit.bu_name }})
                        p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}
                        //- v-list-tile-sub-title(v-html="data.item.title")
                v-flex.autocomplete-result.d-flex.flex-row.align-center.mt-3
                  v-checkbox.mr-2(
                    id="imPayCBHideTTL"
                    v-model="disabledHidetitle",
                    label="Hide Title",
                    :disabled="useAlias"
                  )
                  v-checkbox(id="imPayCBUseAls" v-model="useAlias" label="Use Alias Name")
                  v-checkbox(id="imPayCBShowLogo" style='margin-left:1rem' v-model="useLogo" label="Show Company Logo")
                
                p(style="color: #F08703; font-size: 12px" class="mb-0" v-if="use_setting_max_approver && max_total_approver !== 0") *Each memo may have a maximum of ({{max_total_approver}}) approvers assigned within your Business Unit. Kindly ensure that the approver list does not exceed this limit.
              div(style="padding:0 1rem; flex:1")
                .badge-approval.d-flex.mt-0() 
                  .mr-3
                    img(src="../assets/icon/ic_tips.svg")
                  .align-self-center
                    i Tips: Drag and drop the approver by holding down the left mouse and dragging them. (Approval sequence follow when user input the approver)

                template
                  .mb-5.mt-5
                    p.title.mb-1 Approver
                    ol.autocomplete-results(v-show="approver")
                      draggable.list-group(
                        :list="approver",
                        :disabled="!enabled",
                        ghost-class="ghost",
                        @start="dragging = true",
                        @end="dragging = false"
                      )
                        li.autocomplete-result(
                          v-for="(requestor, i) in approver",
                          :key="requestor.id"
                        )
                          v-chip.list-group-item.ma-1( @click:close="removeApp(requestor)",x-large,close,label) 
                            div
                              p(style="margin:0; font-size:14px !important") {{ requestor.alias }}  {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                              p(style='margin:0; font-size: 12px; color: gray;') {{ requestor.email }}
                              p(v-show="requestor.is_active == false" style="margin:0; color: #FF5252; font-size:12px") Approver is not active

                template
                  .mb-5.mt-5
                  p.title.mb-1 CC
                  ol.autocomplete-results(v-show="tembusan")
                    li.autocomplete-result(
                      v-for="(requestor, i) in tembusan",
                      key="i"
                    )
                      v-chip.ma-1( label x-large ,close @click:close="removeCc(requestor)") 
                        div
                          p(style="margin:0; font-size:14px !important") {{ requestor.alias }}  {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                          p(style='margin:0; font-size: 12px; color: gray;') {{ requestor.email }}
                          p(v-show="requestor.is_active == false" style="margin:0; color: #FF5252; font-size:12px") Account is not active
                      //- v-chip.ma-1(
                      //-   v-if="showApprover",
                      //-   @click:close="removeCc(requestor)",
                      //-   close,
                      //-   label
                      //- ) {{ requestor.alias }} {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                      //- v-chip.ma-1(v-else, label) {{ requestor.alias }} {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
          v-btn(id="imPayPage3Cancel" style="background-color: #f5f5f5;margin-left: 1.5rem" depressed, large, text="" @click="$router.push('/my-request')") Cancel
          v-btn(id="imPayPage3Back" style="margin-left: 0.5rem" dark, color="blue-grey", depressed, large, @click="e1 = 2") Back
          v-btn.ml-2(
            id="imPayPage3btnDraft"
            color="info",
            depressed,
            large,
            :disabled="approver.length == 0 || isLoading",
            :loading="isLoading"
            @click="submitMemo(1)"
          )
            v-icon insert_drive_file
            | &nbsp; Save as Draft
          v-btn(
            id="imPayPage3btnSubmit"
            style="margin: 0.5rem" 
            depressed,
            large,
            color="success",
            :disabled="approver.length == 0 || isLoading",
            :loading="isLoading"
            @click="submitMemo(2)"
          ) 
            v-icon send
            | &nbsp; Submit Request
          
</template>

<script>
import axios from "axios";
//- import * as masterBank from "../data/bank.json";
import { Money } from "v-money";
import draggable from "vuedraggable";
export default {
  components: {
    components: { Money },
    draggable,
  },
  data() {
    return {
      pickerStyle: false,
      useLogo: true,
      dialogChangeCurency: false,
      dialogConfirmDelete: false,
      prevSelectedBUID: null,
      tempDeleteItem: null,
      file: [],
      data_memo: null,
      data_lampiran: [],
    currencyConfigs: {
    },
      moneyAdd: {
        decimal: ",",
        thousands: ".",
        precision: 0,
        masked: false,
      },
      moneyUSDAdd: {
        decimal: ".",
        thousands: ",",
        precision: 2,
        masked: false,
      },
      isLoading: false,
      btnLoader: false,
      uploadAlert: false,
      masterBank: [],
      searchCrossCC: "",
      searchCrossBU: "",
      e1: 1,
      alertMessage: "",
      alert: false,
      enabled: this.$route.fullPath.includes("create-payment-memo")
        ? true
        : false,
      dragging: false,
      approver: [],
      fileName: [],
      tembusan: [],
      myBuMember: [],
      crosBuMember: [],
      listCrossCC: [],
      totalPayment: 0,
      myBuList: [],
      imPayDataSelectedBU: "",
      imPayDataPayTo: "",
      imPayDataBankName: "",
      imPayDataBankNo: "",
      imPayDataInvoiceNo: "",
      imPayDataInvoiceDate: "",
      imPayDataTaxNo: "",
      imPayDataPurpose: "",
      imPayDataTujuan: "",
      addItemName: "",
      addItemPrice: null,
      select: "",
      items: ["BU01", "BU02", "BU03"],
      selectedCurrencyInput:{"text":"IDR","value":"IDR"},
      search: "",
      selectedCurrency: { value: "IDR", text: "IDR" },
      oldSelectedCurrency: { value: "", text: "" },
      headerProps: {
        class: "custom-header",
      },
      headers: [
        {
          text: "Items",
          value: "name",
          sortable: false,
          width: "50%",
        },
        {
          text: "",
          value: "amount",
          sortable: false,
          width: "40%",
        },
        { text: "", value: "actions", sortable: false, width: "10%" },
      ],
      paymentItems: [],
      editedIndex: -1,
      editedItem: {
        id: 0,
        name: "",
        amount: 0,
      },
      defaultItem: {
        id: 0,
        name: "New Item",
        amount: 0,
      },
      useAlias: true,
      hideTitle: [],
      disabledHidetitle: false,
      pickerStyle: false,
      max_total_approver: 0,
      use_setting_max_approver: true,
    };
  },

  computed: {

    currencyBox() {
      return Object.keys(this.currencyConfigs).map(currency => ({
        text: currency,
        value: currency
      }));
    },
    form1Validation() {
      //- return false
      if (
        this.imPayDataSelectedBU &&
        this.imPayDataPayTo &&
        this.imPayDataBankName &&
        this.imPayDataBankNo &&
        this.imPayDataPurpose &&
        this.imPayDataTujuan
      )
        return false;
      return true;
    },
    form2Validation() {
      //- return false
      if (this.paymentItems.length > 0) return false;
      return true;
    },
    getCCData() {
      let result = [];
      for (let i in this.myBuMember) {
        this.myBuMember[i].isCros = false;
        result.push(this.myBuMember[i]);
      }
      return result;
    },
    getCrossCCData() {
      let result = [];
      for (let i in this.listCrossCC) {
        this.listCrossCC[i].isCros = true;
        result.push(this.listCrossCC[i]);
      }
      return result;
    },
  },
  methods: {
    async fetchCurrencyConfigs() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_OLD}/api/currency`)
        this.currencyConfigs = response.data
      } catch (error) {
        console.error('Error fetching currency configurations:', error)
        // Fallback to default configurations...
      }
    },
    truncateFileName(fileName, maxLength) {
      if (fileName.length <= maxLength) {
        return fileName;
      } else {
        const extension = fileName.slice(fileName.lastIndexOf("."));
        const truncatedName = fileName.slice(0, maxLength - extension.length);
        return truncatedName + "..." + extension;
      }
    },
    customFilter(item, queryText, itemText) {
      const textOne = item.text.toLowerCase();
      const textTwo = item.alias.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    trigerChange(e) {
      this.approver = []
      this.myBuMember = []
      this.crosBuMember = []
      this.tembusan = []
      this.listCrossCC = []
      if (this.use_setting_max_approver) {
        let token = localStorage.getItem("token");
        axios
          .get(
            process.env.VUE_APP_API +
              `/business-unit/detail/${
                this.imPayDataSelectedBU.buid
              }`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          )
          .then((res) => {
            
              this.max_total_approver = res.data.max_approver ? res.data.max_approver : 0;
          })
          .catch((err) => {
            this.$toasted.error(err, { icon: "error" });
          })
      }
    },
    handleClearEvent(al) {
      let data1 = [];
      let data2 = [];
      let result = [];
      if (al == 1) {
        data1 = this.approver;
        data2 = this.myBuMember;
      } else if (al == 2) {
        data1 = this.approver;
        data2 = this.crosBuMember;
      } else if (al == 3) {
        data1 = this.tembusan;
        data2 = this.getCCData;
      } else if (al == 4) {
        data1 = this.tembusan;
        data2 = this.getCrossCCData;
      }

      for (let i in data1) {
        let isFound = false;
        for (let j in data2) {
          if (data1[i].id == data2[j].id) isFound = true;
        }
        if (!isFound) result.push(data1[i]);
      }

      if (al == 1 || al == 2) this.approver = result;
      else this.tembusan = result;
    },
    disablePaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData("text/plain");
      if (/^[^a-zA-Z]*$/.test(pastedData)) return;
      event.preventDefault();
    },
    handleChangeCurrency() {
      this.addItemName = "";
      this.addItemPrice = 0;
      if (this.paymentItems.length > 0) this.dialogChangeCurency = true;
      else return;
    },
    numberOnly(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]+$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    sumField(key) {
      // sum data in give key (property)
      const res = this.paymentItems.reduce((a, b) => +a + +(b[key] || 0), 0);
      this.totalPayment = res;
      return res;
    },
    removeCc(item) {
      // const index = this.users.indexOf(item)
      // if (index >= 0) this.users.splice(index, 1)
      let tembusans = this.tembusan.indexOf(item);
      if (this.edit) {
        for (const key in this.tembusan) {
          if (this.tembusan[key].id == item.id) {
            tembusans = key;
            break;
          }
        }
      }
      if (tembusans >= 0) this.tembusan.splice(tembusans, 1);
    },
    removeApp(item) {
      let approvers = this.approver.indexOf(item);
      if (this.edit) {
        for (const key in this.approver) {
          if (this.approver[key].id == item.id) {
            approvers = key;
            break;
          }
        }
      }
      if (approvers >= 0) this.approver.splice(approvers, 1);
    },
    countTotal() {
      let ttl = 0;
      for (let i in this.paymentItems) ttl += +this.paymentItems[i].amount;
      this.totalPayment = ttl;
    },
    editItem(item) {
      this.editedIndex = this.paymentItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
    },
    deleteItem() {
      const index = this.paymentItems.indexOf(this.tempDeleteItem);
      this.paymentItems.splice(index, 1);
      this.countTotal();
      this.tempDeleteItem = null;
    },
    close() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    addNew() {
      
      const currencyNames = Object.keys(this.currencyConfigs)
      if(!currencyNames.includes(this.selectedCurrency.value )){
        alert(`Currency has not been selected. Please choose from the available options: ${currencyNames}`)
        return
      }
      if (!this.addItemName || !this.addItemPrice) return;
      let id = 1;
      for (let i in this.paymentItems) {
        this.paymentItems[i].id = id;
        id++;
      }
      const addObj = Object.assign(
        {},
        {
          name: this.addItemName,
          amount: this.addItemPrice,
          currency: this.selectedCurrency.value,
        }
      );
      addObj.id = this.paymentItems.length + 1;
      this.paymentItems.unshift(addObj);
      this.editItem(addObj);
      this.save();
      this.addItemPrice = 0;
      this.addItemName = "";
    },
    addFile: function () {
      //this.$refs.fileadd.click();
      for (const key in this.$refs.fileadd.files) {
        if (this.$refs.fileadd.files[key].size != undefined) {
          if (this.$refs.fileadd.files[key].size <= 5242880) {
            // 5 MB

            let check = this.file.filter(
              (data) => data.name == this.$refs.fileadd.files[key].name
            );
            if (check.length == 0) {
              this.file.push(this.$refs.fileadd.files[key]);
              this.fileName.push(this.$refs.fileadd.files[key].name);
            }
            this.uploadAlert = false;
          } else {
            //- empty upload file
            this.uploadAlert = true;
            document.getElementById("file").value = "";
          }
        }
      }
    },
    uploadLampiran() {
      this.file = [];

      for (const key in this.$refs.file.files) {
        if (this.$refs.file.files[key].size != undefined) {
          if (this.$refs.file.files[key].size <= 5242880) {
            // 5 MB

            let check = this.file.filter(
              (data) => data.name == this.$refs.file.files[key].name
            );
            if (check.length == 0) {
              this.file.push(this.$refs.file.files[key]);
              this.fileName.push(this.$refs.file.files[key].name);
            }

            //- this.file[key] = this.$refs.file.files[key];
            //- this.fileName[key] = this.$refs.file.files[key].name;
            this.uploadAlert = false;
          } else {
            //- empty upload file
            this.uploadAlert = true;
            document.getElementById("file").value = "";
          }
        }
      }
    },
    removeLampiran(name, index) {
      this.fileName.splice(this.fileName.indexOf(name), 1);
      this.file.splice(index, 1);

      this.$refs.fileadd.value = "";
      if (this.fileName.length == 0 && this.file.length == 0) {
        this.clearFile = true;
        this.dataEditRequest.imFileLampiran = [];
      }

      this.dataEditRequest.imFileLampiran = [];
      this.fileName.forEach((item) => {
        if (item.url != null) {
          this.dataEditRequest.imFileLampiran.push(item);
        }
      });
    },
    save() {
      if (!this.editedItem.amount || !this.editedItem.name) return;
      if (this.editedIndex > -1) {
        Object.assign(this.paymentItems[this.editedIndex], this.editedItem);
      }
      this.countTotal();
      this.close();
    },
    changeCurency() {
      //- for(let i in this.paymentItems)this.paymentItems[i].currency = this.selectedCurrency.value
      this.paymentItems = [];
    },
    async getMyActiveBU() {
      try {
        const token = localStorage.getItem("token");
        const userId = this.$store.state.dataUsers.user;
        if (userId) {
          const reqDataBU = await axios.get(
            `${process.env.VUE_APP_API}/users/active/bu/${userId._id}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          const listBU = reqDataBU.data.data;
          for (let i in listBU) {
            if (listBU.length == 1)
              listBU[i].label = `${listBU[i].business_unit.bu_name}`;
            else
              listBU[i].label = `${listBU[i].business_unit.bu_name} as ${
                listBU[i].position ? listBU[i].position : ""
              }`;
            listBU[i].value = {
              buid: listBU[i].business_unit.id,
              userid: listBU[i].id,
            };
          }
          this.myBuList = listBU;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getCrossBUMember() {
      try {
        const token = localStorage.getItem("token");
        this.crosBuMember = [];
        const reqDataCrossBUMember = await axios.get(
          `${process.env.VUE_APP_API}/users/busines-unit/${this.imPayDataSelectedBU.buid}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const dataCrossBUMember = reqDataCrossBUMember.data.data;
        for (let i in dataCrossBUMember)
          if (
            dataCrossBUMember[i].email != this.$store.state.dataUsers.user.email
          )
            for (let j in this.approver)
              if (this.approver[i].email == dataCrossBUMember[i].email)
                this.crosBuMember.push(dataCrossBUMember[i]);
      } catch (e) {
        console.log(e);
      }
    },
    async getMyBUMember() {
      try {
        const token = localStorage.getItem("token");
        const reqDataMyBUMember = await axios.get(
          `${process.env.VUE_APP_API}/users/bu/list/${this.imPayDataSelectedBU.buid}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const dataMyBUMember = reqDataMyBUMember.data.data;
        this.myBuMember = dataMyBUMember;
      } catch (e) {
        console.log(e);
      }
    },
    UploadAttachtment: async function (data) {
      let formData = new FormData();
      formData.append("attachment", data);
      const config = {
        method: "post",
        url: process.env.VUE_APP_API + `/memo/upload-file`,
        headers: {
          Authorization: `Bearer ${this.$store.state.token}`,
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      };
      await axios(config)
        .then((res) => {
          //this.data_memo.attachment.push(res.data.data)
          this.data_lampiran.push(res.data.data);
          //this.data_memo.attachment = res.data.data
        })
        .catch((err) => {
          let err_msg = err.response && err.response.data.message;
          this.$toasted.error(err_msg, { icon: "error" });
        });
    },
    async submitMemo(act) {
      this.isLoading = true;
      try {
        const reqCreatorData = await axios.get(
          `${process.env.VUE_APP_API}/memo/creator/${this.imPayDataSelectedBU.userid}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.token}`,
            },
          }
        );
        const creator_data = reqCreatorData.data.data;
        creator_data.name = this.$store.state.dataUsers.user.full_name;

        const chosenBUDetail = await axios.get(
          `${process.env.VUE_APP_API}/business-unit/detail/${this.imPayDataSelectedBU.buid}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.token}`,
            },
          }
        );
        chosenBUDetail.data.id = chosenBUDetail.data._id;
        delete chosenBUDetail.data._id;

        //- CONTAIN INTERNAL AND CROSS BU APPV
        const approvers = [];

        if (this.tembusan) {
          for (const item of this.tembusan) {
            if (!item.is_active) {
              this.errorActiveUserMsg =
                statusBeforeSubmit == 3
                  ? "Sorry, there is inactive account. Please contact admin or withdraw memo."
                  : "Sorry, there is inactive account. Please close or change new account.";
              this.dialogInactiveApprover = true;
              this.isLoading = false;
              this.status = statusBeforeSubmit;
              return;
            }
          }
        }

        for (const item of this.approver) {
          if (!item.is_active) {
            this.errorActiveUserMsg =
              statusBeforeSubmit == 3
                ? "Sorry, there is inactive account. Please contact admin or withdraw memo."
                : "Sorry, there is inactive account. Please close or change new account.";
            this.dialogInactiveApprover = true;
            this.isLoading = false;
            this.status = statusBeforeSubmit;
            return;
          }
          if (typeof item.comment === "undefined") {
            this.$set(item, "comment", null);
          }

          if (this.useAlias) {
            this.$set(item, "name", item.name);
          }

          this.$set(item, "postAs", "approver");

          approvers.push(item);
        }

        let newApp = approvers;
        if (act == 2) newApp[0].status = 9;

        let formData = new FormData();
        formData.append("userId", this.$store.state.dataUsers.user._id);
        formData.append("user", JSON.stringify(creator_data));
        formData.append("imType", 6);
        formData.append("imTujuan", this.imPayDataTujuan.replace(/<meta charset="utf-8">/g, '').replace(/dir="ltr"/g,''));
        formData.append("imStatus", act);
        formData.append("imOrganization", JSON.stringify(chosenBUDetail.data));
        formData.append("imTargetDate", new Date().toISOString().substr(0, 10));
        formData.append("imUseAlias", this.useAlias ? true : false);
        formData.append("imHideTitle", this.disabledHidetitle ? true : false);
        formData.append("imApprover", JSON.stringify(newApp));
        formData.append("imCC", JSON.stringify(this.tembusan));
        formData.append("imGroup", "nongroup");
        formData.append(
          "imPerihal",
          this.imPayDataPurpose.replaceAll(`"`, `'`).replace(/<meta charset="utf-8">/g, '').replace(/dir="ltr"/g,'')
        );
        formData.append("imPayDataPayTo", this.imPayDataPayTo);
        formData.append("imPayDataBankName", this.imPayDataBankName);
        formData.append("imPayDataBankNo", this.imPayDataBankNo);
        formData.append("imPayDataInvoiceNo", this.imPayDataInvoiceNo);
        formData.append("imPayDataInvoiceDate", this.imPayDataInvoiceDate);
        formData.append("imPayDataTaxNo", this.imPayDataTaxNo);
        formData.append("imUseLogo", this.useLogo);
        formData.append(
          "imPaymentData",
          JSON.stringify({
            paymentCurrency: this.selectedCurrency,
            paymentItems: this.paymentItems,
            paymentTotal: this.totalPayment,
          })
        );
        if (this.file.length > 0) {
          for (const key in this.file) {
            await this.UploadAttachtment(this.file[key]);
          }
          this.data_memo = this.data_lampiran;
          formData.append("imFileLampiran", JSON.stringify(this.data_memo));
          formData.append("imFilelength", this.file.length);
        }
        const configSubmitMemoReq = {
          method: "post",
          url: process.env.VUE_APP_API_OLD + `/api/requests`,
          headers: { "Content-Type": "multipart/form-data" },
          data: formData,
        };
        const submitMemoReq = await axios(configSubmitMemoReq);

        if (submitMemoReq.status == 200) {
          this.isLoading = false;
          act == 1
            ? this.$toasted.info("Memo has been successfully saved to draft", {
                icon: "save",
              })
            : this.$toasted.success(
                "Success, the memo was successfully generated and sent to the approver.",
                { icon: "check_circle" }
              );
          this.$router.push("/my-request");
        }
      } catch (e) {
        console.log(e);
        console.log(e);
      }
    },
    setUseAlias() {
      if (this.useAlias) {
        this.disabledHidetitle = true;
      }
    },
    getMoneyFormat(currency) {
      return this.currencyConfigs[currency] || this.currencyConfigs.USD;
    },
  },

  watch: {
    selectedCurrencyInput(val){
      this.selectedCurrency = {"text":val,"value":val}
    },
    disabledHidetitle(val) {
      if (val != false || val != 0) {
        for (const key in this.bod) {
          this.hideTitle.push(this.bod[key].id);
        }
      } else {
        this.hideTitle = [];
      }
    },

    useAlias(val) {
      if (val != false || val != 0) {
        this.disabledHidetitle = true;
      } else if (this.disabledHidetitle == true && val == true) {
        this.disabledHidetitle = false;
        this.hideTitle = [];
      } else {
        this.hideTitle = [];
      }
    },
    async searchCrossCC(val) {
      try {
        if (val.length >= 3 && val.trim().length) {
          const token = localStorage.getItem("token");
          const { data } = await axios.get(
            `${process.env.VUE_APP_API}/users/busines-unit/${this.imPayDataSelectedBU.buid}?key=${val}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          const res = data.data;
          // if (res.length != 0 ) this.listCrossCC = []
          for (let i in res)
            if (
              res[i].is_active &&
              res[i].name != this.$store.state.dataUsers.user.full_name
            )
              this.listCrossCC.push(res[i]);
        }
      } catch (e) {
        if (e.response.status == 401 || e.response.status == 403) {
          this.$store.dispatch("logout");
          return this.$router.push("/");
        }
      } finally {
      }
    },
    async searchCrossBU(val) {
      try {
        if (val.length >= 3 && val.trim().length) {
          //- this.isLoading = true;
          const token = localStorage.getItem("token");
          const { data } = await axios.get(
            `${process.env.VUE_APP_API}/users/busines-unit/${this.imPayDataSelectedBU.buid}?key=${val}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          const res = data.data;
          //- if (res.length != 0 ) this.crosBuMember = []
          for (let i in res)
            if (
              res[i].is_active &&
              res[i].name != this.$store.state.dataUsers.user.full_name
            )
              this.crosBuMember.push(res[i]);
        }
      } catch (e) {
        if (e.response.status == 401 || e.response.status == 403) {
          this.$store.dispatch("logout");
          return this.$router.push("/");
        }
      } finally {
        //- this.isLoading = false
      }
    },
    approver() {
      if (this.approver.length <= 0) {
        this.alert = false;
      }
      if (this.approver.length > 0) {
        let approver = this.approver[this.approver.length - 1];
        let isBreak = false;

        if (this.use_setting_max_approver && this.max_total_approver !== 0 && this.approver.length > this.max_total_approver) {
          this.alertMessage =
            `It reaches the maximum number (${this.max_total_approver}) of approver allowed in your BU!`;
          this.alert = true;
          this.approver.pop();
        } else {
          for (const iterator of this.tembusan) {
            if (isBreak) break;
            if (approver.id == iterator.id) {
              // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Approver (Budget), silakan pilih salah satu!');
              this.alertMessage =
                "The user you selected has been selected in the previous input field, please choose one!";
              isBreak = true;
              this.alert = true;
              this.approver.pop();
              break;
            }
          }
        }
      }
    },
    tembusan() {
      if (this.tembusan.length > 0) {
        let tembusan = this.tembusan[this.tembusan.length - 1];
        let isBreak = false;

        for (const iterator of this.approver) {
          if (isBreak) break;
          if (tembusan.id == iterator.id) {
            // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Approver (beside BOD), silakan pilih salah satu!');
            isBreak = true;
            this.alertMessage =
              "The user you selected has been selected in the previous input field, please choose one!";
            this.alert = true;
            this.tembusan.pop();
            break;
          }
        }
      }
    },
    selectedCurrency(val, oldVal) {
      if (val !== oldVal) {
        this.oldSelectedCurrency = oldVal;
      }
    },
  },

  created() {
    this.fetchCurrencyConfigs()
    setTimeout(() => {
      this.getMyActiveBU();
    }, 1000);
  },

  mounted: async function () {
    this.setUseAlias();
    const listBankResp = await axios.get(
      `${process.env.VUE_APP_API_OLD}/api/list_bank`
    );
    this.masterBank = listBankResp.data || [];
    for (let i in this.masterBank) {
      this.masterBank[i].value = this.masterBank[i].text;
      if (!this.masterBank[i].alias)
        this.masterBank[i].alias = this.masterBank[i].text;
    }
  },
};
</script>
<style>
.IMP-group-form {
  display: flex;
}

.IMP-title-form {
  margin: auto;
}

#dtbl th {
  background-color: #f0f0f0 !important; /* Ganti dengan warna yang diinginkan */
  color: #333; /* Ganti dengan warna teks yang diinginkan */
}
#dtbl th span {
  font-weight: bold;
  font-size: 18px;
}

#ThisToolbar .v-toolbar__content {
  padding: 0px !important;
  box-shadow: none !important;
}
td .v-money {
  text-align: right;
  width: 90%;
}
th .v-money {
  text-align: right;
  width: 90%;
}
</style>
